import * as z from 'zod/v4-mini';
import { API_NAME_REGEX } from './api-name';

export const notEmpty = z.minLength(1, '$t:validation.not_empty');
export const nonEmptyString = (params?: Parameters<typeof z.string>[0]) =>
	z.string({ error: '$t:validation.not_empty', ...(typeof params === 'string' ? { error: params } : params) }).check(notEmpty);

export const DbSafeString = z.string({ error: '$t:validation.not_empty' }).check(notEmpty, z.regex(/^\w+$/, '$t:validation.db_safe_string'));
export const ApiSafeString = z.string({ error: '$t:validation.not_empty' }).check(notEmpty, z.regex(/^\w[\w-]*$/, '$t:validation.api_safe_string'));
// Ordered checks so the inline error names the actual problem (the help text
// carries the full rule); the form shows the first failing check.
export const ApiNameSafeString = z.string({ error: '$t:validation.not_empty' }).check(
	notEmpty,
	z.regex(/^[A-Z]/i, '$t:validation.api_name_must_start_with_letter'),
	z.regex(API_NAME_REGEX, '$t:validation.api_name_safe_string'),
);
